module.exports = __webpack_public_path__ + "static/media/so-end-duck.646d9596.svg";